module.exports = __webpack_public_path__ + "img/farming_56.9b46d059.png";